export default __webpack_public_path__ + "static/media/14.230115fd.jpg";